import { useEffect, useRef, useState } from 'react';
import { useScrollSpy } from '../utils/useScrollSpy';
import { useLanguage } from '../context/LanguageContext';
import { getTranslation } from '../translations/translations';

const sections = [
  "home",
  "features",
  "modules",
  "benefits",
  "faq",
  "contact",
];
const Navbar = () => {

  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { language, changeLanguage } = useLanguage();
  const menuRef = useRef(null);
  const togglerRef = useRef(null);

  const activeSection = useScrollSpy(sections);



  useEffect(() => {
    let ticking = false;
    
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrolled(window.scrollY > 50);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) && 
          togglerRef.current && !togglerRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };

  const handleMenuItemClick = () => {
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar navbar-expand-lg navbar-light navbar-custom fixed-top ${scrolled ? 'scrolled' : ''}`} style={{top: 43, zIndex: 1001}}>
      <div className="container">
        <a className="navbar-brand" href="#home">
          <img src='Pruna School Logo.png' alt='..'/> Purna <span>Academic</span>
        </a>
        
        <button 
          ref={togglerRef}
          className="navbar-toggler focus-ring focus-ring-white" 
          type="button" 
          onClick={handleMenuToggle}
          aria-controls="navbarNav" 
          aria-expanded={menuOpen}
          aria-label="Toggle navigation"
        >
          {menuOpen ? (
            <i className="bi bi-x-lg"></i>
          ) : (
            <span className="navbar-toggler-icon"></span>
          )}
        </button>
        
        <div 
          ref={menuRef}
          className={`collapse navbar-collapse ${menuOpen ? 'show' : ''}`} 
          id="navbarNav"
        >
          <ul className="navbar-nav ms-auto me-3">
            {sections.map((id) => (
              <li className="nav-item" key={id}>
                <a
                  href={`#${id}`}
                  className={`nav-link ${
                    activeSection === id ? "active" : ""
                  }`}
                  onClick={handleMenuItemClick}
                >
                  {getTranslation(language, `nav.${id}`)}
                </a>
              </li>
            ))}
          </ul>
          <div className="d-flex gap-2 align-items-center">
            <select 
              value={language}
              onChange={(e) => {
                changeLanguage(e.target.value);
                handleMenuItemClick();
              }}
              className="form-select form-select-sm fw-bold border-2"
              style={{ width: 'auto', color: '#333', borderColor: '#ddd' }}
            >
              <option value="en"  className='bg-white hover:bg-primary hover:text-white'>ENG</option>
              <option value="mr"  className='bg-white hover:bg-primary hover:text-white'>मराठी</option>
            </select>
            <a href="#contact" className="btn btn-demo" onClick={handleMenuItemClick}>
              <i className="bi bi-calendar-check me-2"></i>{getTranslation(language, 'nav.bookDemo')}
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
